import { CloseIcon } from '@chakra-ui/icons';
import { Box, IconButton } from '@chakra-ui/react';

import { Text } from '@revelio/ui';

import type { CustomFilter } from '../../data-builder.store';
import { DataBuilderOption } from '../ui/DataBuilderOption';

type AddCustomFilterOptionProps = {
  onClick: () => void;
};

export function AddCustomFilterOption({ onClick }: AddCustomFilterOptionProps) {
  return (
    <DataBuilderOption
      data-testid="data-builder-add-custom-filter"
      isSelected={false}
      onClick={onClick}
      startSlot={<DataBuilderOption.CheckBox isSelected={false} />}
    >
      <Text fontSize="md" style={{ color: 'var(--chakra-colors-blue-300)' }}>
        + Add Filter
      </Text>
    </DataBuilderOption>
  );
}

type AddSeparateCustomFilterOptionProps = {
  filterName: string;
  testIdSuffix: string;
  onClick: () => void;
};

export function AddSeparateCustomFilterOption({
  filterName,
  testIdSuffix,
  onClick,
}: AddSeparateCustomFilterOptionProps) {
  return (
    <DataBuilderOption
      data-testid={`data-builder-add-separate-custom-filter-${testIdSuffix}`}
      isSelected={false}
      onClick={onClick}
      startSlot={<DataBuilderOption.CheckBox isSelected={false} />}
    >
      <Text fontSize="md" style={{ color: 'var(--chakra-colors-blue-300)' }}>
        + {filterName}
      </Text>
    </DataBuilderOption>
  );
}

type CustomFilterCardProps = {
  filter: CustomFilter;
  onClick: () => void;
  onRemove: () => void;
};

export function CustomFilterCard({
  filter,
  onClick,
  onRemove,
}: CustomFilterCardProps) {
  return (
    <Box position="relative">
      <DataBuilderOption
        data-testid={`data-builder-custom-filter-${filter.name}`}
        isSelected
        onClick={onClick}
        startSlot={<DataBuilderOption.CheckBox isSelected />}
      >
        <Text fontSize="md">{filter.name}</Text>
      </DataBuilderOption>
      <IconButton
        aria-label={`Remove filter ${filter.name}`}
        icon={<CloseIcon boxSize={2} />}
        size="xs"
        variant="ghost"
        colorScheme="red"
        position="absolute"
        top="50%"
        transform="translateY(-50%)"
        right={1}
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        data-testid={`data-builder-remove-custom-filter-${filter.name}`}
      />
    </Box>
  );
}
